/* The Dopamine Edit — swatches, colour tabs, reveal on scroll */
(function () {
  if (window.__deInit) return;
  window.__deInit = true;

  function initSwatches(root) {
    root.querySelectorAll('[data-de-card]').forEach(function (card) {
      if (card.__de) return;
      card.__de = true;
      var img = card.querySelector('.de-card__img--main');
      var label = card.querySelector('[data-de-colour]');
      var idInput = card.querySelector('input[name="id"]');
      card.querySelectorAll('[data-de-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          card.querySelectorAll('[data-de-swatch]').forEach(function (s) {
            s.setAttribute('aria-pressed', s.dataset.name === sw.dataset.name ? 'true' : 'false');
          });
          var hover = card.querySelector('.de-card__img--hover');
          if (hover && sw.dataset.src) hover.remove();
          if (label) label.textContent = sw.dataset.name;
          if (img && sw.dataset.src) {
            img.src = sw.dataset.src;
            if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
            img.alt = sw.dataset.alt || img.alt;
          }
          if (idInput && sw.dataset.variant) idInput.value = sw.dataset.variant;
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-de-tabs]').forEach(function (wrap) {
      if (wrap.__de) return;
      wrap.__de = true;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); next.focus(); select(next); }
        });
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.de-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 90 + 'ms'; io.observe(el); });
  }

  function init(root) { initSwatches(root); initTabs(root); initReveal(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
